import { render } from "./LayoutHeadingTabs.vue?vue&type=template&id=03129d49&scoped=true"
import script from "./LayoutHeadingTabs.vue?vue&type=script&lang=js"
export * from "./LayoutHeadingTabs.vue?vue&type=script&lang=js"

import "./LayoutHeadingTabs.vue?vue&type=style&index=0&id=03129d49&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03129d49"]])

export default __exports__